export const ROLE_LABELS = {
  user: 'Uporabnik',
  'local-admin': 'Administrator enote',
  admin: 'Administrator',
};

export function formatRoleLabel(role) {
  return ROLE_LABELS[role] || role || '';
}
